import { connect } from 'react-redux';

import MarkdownSubmitButton from '../components/MarkdownExercise/CustomSubmitButton';
import * as actions from '../redux/actions';
import * as selectors from '../redux/selectors';

const mapStateToProps = (state: any, ownProps: any) => ({
  markdown: selectors.selectMarkdown(state).toJS(),
  isActive: selectors
    .selectInputMarkdownTabs(state)
    .getIn([ownProps.ckey, 'props', 'active']),
});

const mapDispatchToProps = (dispatch: any) => ({
  onUpdateActivateTitle: (settings: any) =>
    dispatch(actions.updateMarkdownActiveTitle(settings)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(MarkdownSubmitButton);
